<div class="config-tab">
  <h2>Config</h2>

  @if (loading()) {
    <p>Loading configuration...</p>
  } @else {
    <form class="config-form" [formGroup]="form">
      <label for="lotteryClosedMappingStartDate">
        Closed mapping start date
      </label>
      <input
        id="lotteryClosedMappingStartDate"
        type="date"
        pInputText
        formControlName="lotteryClosedMappingStartDate"
      />
      <p class="hint">
        Pending-selection applications with lottery number &gt; 1000 and selection date older than 2 months
        will be shown as closed for lotteries created after this date.
      </p>
      <div class="toggle-field">
        <p-toggleswitch
          formControlName="marketingSmsEnabled"
          inputId="marketingSmsEnabled"
        ></p-toggleswitch>
        <label for="marketingSmsEnabled">Marketing SMS enabled</label>
      </div>
      <p class="hint">
        When disabled, marketing/promotional SMS messages will be skipped (marked as sent but not actually delivered).
      </p>
      <div class="toggle-field">
        <p-toggleswitch
          formControlName="nycAccountAccessEnabled"
          inputId="nycAccountAccessEnabled"
        ></p-toggleswitch>
        <label for="nycAccountAccessEnabled">NYC account access enabled</label>
      </div>
      <p class="hint">
        When disabled, users will see a temporary maintenance message instead of their Housing Connect username and password.
      </p>
      <div class="toggle-field">
        <p-toggleswitch
          formControlName="checkoutCouponsEnabled"
          inputId="checkoutCouponsEnabled"
        ></p-toggleswitch>
        <label for="checkoutCouponsEnabled">Checkout promotion codes enabled</label>
      </div>
      <p class="hint">
        When enabled, users will see a promo code field on initial Stripe Checkout. Does not affect resubscribe.
      </p>
      <p-button
        label="Save"
        [loading]="saving()"
        (onClick)="save()"
      ></p-button>
    </form>
  }
</div>
